// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  font-size: clamp(14px, 1.2vw, 16px);
}
.layout.light {
          --bg-primary: #ffffff;
          --bg-secondary: #f8fafc;
          --bg-tertiary: #f1f5f9;
          --text-primary: #0f172a;
          --text-secondary: #475569;
          --text-tertiary: #94a3b8;
          --border: #e2e8f0;
          --border-light: #f1f5f9;
          --accent: #3b82f6;
          --accent-hover: #2563eb;
          --success: #10b981;
          --warning: #f59e0b;
          --danger: #ef4444;
          --shadow: rgba(15, 23, 42, 0.08);
          --shadow-lg: rgba(15, 23, 42, 0.12);
        }

        .layout.dark {
          --bg-primary: #0f172a;
          --bg-secondary: #1e293b;
          --bg-tertiary: #334155;
          --text-primary: #f1f5f9;
          --text-secondary: #cbd5e1;
          --text-tertiary: #64748b;
          --border: #334155;
          --border-light: #1e293b;
          --accent: #3b82f6;
          --accent-hover: #60a5fa;
          --success: #10b981;
          --warning: #f59e0b;
          --danger: #ef4444;
          --shadow: rgba(0, 0, 0, 0.3);
          --shadow-lg: rgba(0, 0, 0, 0.5);
        }

        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        /* ================= BASE LAYOUT ================= */
        .layout {
          display: flex;
          height: 100vh;
          overflow: hidden;
          min-height: 100dvh;        /* 🔥 dynamic viewport (mobile safe) */
          width: 100%;
          overflow: hidden;
          background: var(--bg-secondary);
          color: var(--text-primary);
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', sans-serif;
          transition: background 0.3s ease, color 0.3s ease;
        }

        /* ================= TOPBAR (FULL WIDTH) ================= */
        .topbar {
          height: 72px;
          background: var(--bg-primary);
          border-bottom: 1px solid var(--border);
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 clamp(12px, 4vw, 24px);
          flex-shrink: 0;
          transition: background 0.3s ease;
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          z-index: 1100;
        }
@media (max-width: 600px) {
  .user-name {
    display: none;
  }
}
        .topbar-left {
          display: flex;
          align-items: center;
          gap: 28px;
          flex-shrink: 0;        /* 🔥 IMPORTANT */

        }
        .title-group {
          display: flex;
          flex-direction: column;
          gap: 2px;
        }

        .page-title {
          font-size: 22px;
          font-weight: 700;
          color: var(--text-primary);
          margin: 0;
        }

        .page-subtitle {
          font-size: 14px;
          color: var(--text-tertiary);
          margin: 0;
        }

.topbar-logo {        /* controls height */
  width: auto;         /* keeps aspect ratio */
  max-width: 260px;    /* prevents overflow */
  object-fit: contain;
  display: block;
}
        .hamburger {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: transparent;        /* 🔥 remove filled box */
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--text-primary);     /* icon color */
  transition: background 0.2s ease, transform 0.1s ease;
    padding: 0 !important;   /* override global button padding */
      flex-direction: column;     /* 🔥 THIS is the key */
        gap: 6px;



}

.hamburger:hover {
  background: var(--bg-tertiary);
}

.hamburger:active {
  transform: scale(0.95);
}
.hamburger span {
  width: 28px;
  height: 2px;              /* thick lines */
  background: var(--text-primary);
  border-radius: 2px;
  transition: transform 0.2s ease, opacity 0.2s ease;
}
        .topbar-right {
          display: flex;
          align-items: center;
          gap: 16px;
        }

        .theme-toggle {
          width: 40px;
          height: 40px;
          border-radius: 10px;
          background: var(--bg-secondary);
          border: 1px solid var(--border);
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          font-size: 18px;
          transition: all 0.2s ease;
        }

        .theme-toggle:hover {
          background: var(--bg-tertiary);
          transform: scale(1.05);
        }

        .user-menu {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 8px 16px 8px 8px;
          background: var(--bg-secondary);
          border-radius: 12px;
          border: 1px solid var(--border);
          cursor: pointer;
          transition: all 0.2s ease;
        }

        .user-menu:hover {
          background: var(--bg-tertiary);
        }

        .user-avatar {
          width: 36px;
          height: 36px;
          border-radius: 8px;
          background: linear-gradient(135deg, var(--accent), #8b5cf6);
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-weight: 600;
          font-size: 14px;
        }

        .user-name {
          font-size: 14px;
          font-weight: 500;
          color: var(--text-primary);
        }

        /* ================= SIDEBAR ================= */
        .sidebar {
          width: 200px;
          background: var(--bg-primary);
          border-right: 1px solid var(--border);
          padding: 24px 16px;
          display: flex;
          flex-direction: column;
          position: fixed;
          top: 72px; /* below topbar */
          left: 0;
          height: calc(100vh - 72px);
          z-index: 1000;
          transition: transform 0.2s ease, background 0.3s ease;
        }

        .sidebar.closed {
          transform: translateX(-100%);
        }

        .nav-menu {
          display: flex;
          flex-direction: column;
          gap: 4px;
        }

        .nav-item {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 12px 16px;
          background: transparent;
          border: none;
          border-radius: 10px;
          color: var(--text-secondary);
          font-size: 15px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s ease;
          width: 100%;
          text-align: left;
            opacity: 0.85;

        }

        .nav-item:hover {
          background: var(--bg-tertiary);
          color: var(--text-primary);
            opacity: 1;

        }

        .nav-item.active {
          background: var(--accent);
  color: #ffffff;             /* ✅ clear, readable */
          box-shadow: 0 4px 12px rgba(59, 130, 246, 0.25);
        }

        .nav-item svg {
          flex-shrink: 0;
        }

        /* ================= MAIN AREA ================= */
        .main {
          margin-left: 200px;
          margin-top: 72px; /* below topbar */
          flex: 1 1;
          display: flex;
          flex-direction: column;
          /*height: calc(100vh - 72px);*/
          overflow: hidden;
          min-width: 0;             /* 🔥 prevents horizontal overflow */
          height: auto;
          transition: margin-left 0.2s ease;
        }

        .main.full {
          margin-left: 0;
        }

        /* ================= SCROLLABLE CONTENT ================= */
        .content {
          padding:  clamp(16px, 4vw, 32px);   
          overflow-y: auto;
          flex: 1 1;
          width: 100%;

        }

        /* ================= STATS GRID ================= */
        .stats-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit,     minmax(min(100%, 240px), 1fr)
          );
          gap: clamp(12px, 3vw, 20px);
          margin-bottom: 32px;
        }

        .stat-card {
          background: var(--bg-primary);
          border: 1px solid var(--border);
         padding: clamp(16px, 3vw, 24px);
  border-radius: clamp(12px, 3vw, 16px);
          display: flex;
          gap: 16px;
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
        }

        .stat-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 3px;
          background: var(--accent);
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        .stat-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 24px var(--shadow-lg);
        }

        .stat-card:hover::before {
          opacity: 1;
        }

        .stat-card.primary::before { background: var(--accent); }
        .stat-card.success::before { background: var(--success); }
        .stat-card.warning::before { background: var(--warning); }
        .stat-card.danger::before { background: var(--danger); }

        .stat-icon {
          width: 48px;
          height: 48px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          background: var(--bg-secondary);
          color: var(--accent);
        }

        .stat-card.primary .stat-icon {
          background: rgba(59, 130, 246, 0.1);
          color: var(--accent);
        }

        .stat-card.success .stat-icon {
          background: rgba(16, 185, 129, 0.1);
          color: var(--success);
        }

        .stat-card.warning .stat-icon {
          background: rgba(245, 158, 11, 0.1);
          color: var(--warning);
        }

        .stat-card.danger .stat-icon {
          background: rgba(239, 68, 68, 0.1);
          color: var(--danger);
        }

        .stat-content {
          flex: 1 1;
        }

        .stat-label {
          font-size: 13px;
          font-weight: 500;
          color: var(--text-tertiary);
          margin-bottom: 4px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }
/* ===== Input group (calendar field) ===== */
.input-group {
  position: relative;
  width: 100%;
}

.input-group input {
  width: 100%;
  padding: 12px 42px 12px 12px;
  border: 1px solid var(--border);
  border-radius: 8px;
  font-size: 14px;
  background: var(--bg-primary);
  color: var(--text-primary);
}

/* FIXED ICON ALIGNMENT */
.input-icon {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%); /* 🔥 THIS FIXES ALIGNMENT */
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-tertiary);
  font-size: 18px;
  pointer-events: auto;
  cursor: pointer;
}
.modal label {
  display: block;
  margin-top: 14px;
  margin-bottom: 6px;
  font-size: 13px;
  font-weight: 500;
  color: var(--text-secondary);
}
.error-text {
  color: var(--danger);
  font-size: 12px;
  margin-top: 4px;
}

.input-error {
  border: 1px solid var(--danger) !important;
}
.modal input,
.modal select {
  width: 100%;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid var(--border);
  background: var(--bg-primary);
  color: var(--text-primary);
}
        .stat-value {
          font-size: 32px;
          font-weight: 700;
          color: var(--text-primary);
          margin: 0;
          line-height: 1;
        }

        .stat-description {
          font-size: 13px;
          color: var(--text-tertiary);
          margin-top: 4px;
        }

        .stat-trend {
          font-size: 12px;
          margin-top: 8px;
          padding: 4px 8px;
          border-radius: 6px;
          display: inline-block;
        }

        .stat-trend.positive {
          background: rgba(16, 185, 129, 0.1);
          color: var(--success);
        }

        .stat-progress {
          width: 100%;
          height: 4px;
          background: var(--bg-secondary);
          border-radius: 2px;
          margin-top: 12px;
          overflow: hidden;
        }

        .stat-progress-bar {
          height: 100%;
          border-radius: 2px;
          transition: width 0.3s ease;
        }

        .stat-progress-bar.success {
          background: var(--success);
        }

        .status-dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          display: inline-block;
        }

        .status-dot.online {
          background: var(--success);
          box-shadow: 0 0 8px var(--success);
        }

        .status-dot.offline {
          background: var(--danger);
          box-shadow: 0 0 8px var(--danger);
        }

        /* ================= SECTION HEADER ================= */
        .section-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;
        }

        .section-header h2 {
          font-size: 20px;
          font-weight: 700;
          color: var(--text-primary);
        }

        .btn-secondary {
          padding: 8px 16px;
          background: var(--bg-secondary);
          border: 1px solid var(--border);
          border-radius: 8px;
          color: var(--text-primary);
          font-size: 14px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s ease;
        }

        .btn-secondary:hover {
          background: var(--bg-tertiary);
        }

        /* ================= PLAYERS TABLE ================= */
        .table-container,
        .players-table-container {
          background: var(--bg-primary);
          border: 1px solid var(--border);
          border-radius: 16px;
  overflow: visible;              /* 🔥 ENABLE horizontal scroll */
        }

        .players-table {
          width: 100%;
  table-layout: fixed;       /* 🔥 KEY: forces proportional shrink */
  border-collapse: separate;
  border-spacing: 0;
        }

        .players-table thead {
          background: var(--bg-secondary);
        }

        .players-table th {
          padding: 16px 20px;
          text-align: left;
          font-size: 12px;
          font-weight: 600;
          color: var(--text-tertiary);
          text-transform: uppercase;
          letter-spacing: 0.5px;
          border-bottom: 1px solid var(--border);
           white-space: nowrap;
  padding: 12px 14px;
             white-space: nowrap;

        }

        .players-table td {
          padding: 16px 20px;
          border-bottom: 1px solid var(--border-light);
           white-space: nowrap;
  padding: 12px 14px;
    max-width: 0;        /* 🔥 enables wrapping in fixed layout */

        }

        .players-table tbody tr:last-child td {
          border-bottom: none;
        }

        .players-table tbody tr {
          transition: background 0.2s ease;
        }

        .players-table tbody tr:hover {
          background: var(--bg-secondary);
        }

        .player-name {
          display: flex;
          align-items: center;
          gap: 10px;
          color: var(--text-primary);
          font-weight: 500;
        }

        .status-badge {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          padding: 6px 12px;
          border-radius: 8px;
          font-size: 13px;
          font-weight: 500;
        }

        .status-badge.online {
          background: rgba(16, 185, 129, 0.1);
          color: var(--success);
        }

        .status-badge.offline {
          background: rgba(239, 68, 68, 0.1);
          color: var(--danger);
        }

        .status-badge .status-dot {
          width: 6px;
          height: 6px;
        }

        .playlist-badge {
          padding: 6px 12px;
          background: var(--bg-secondary);
          border-radius: 8px;
          font-size: 13px;
          color: var(--text-primary);
        }

        .text-muted {
          color: var(--text-tertiary);
          font-size: 13px;
        }

        .action-buttons {
          gap: 8px;
          justify-content: center;
        }

        .btn-icon {
          width: 32px;
          height: 32px;
          border-radius: 6px;
          background: var(--bg-secondary);
          border: 1px solid var(--border);
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          flex-shrink: 0;
          font-size: 16px;
          transition: all 0.2s ease;
        }

        .btn-icon:hover {
          background: var(--bg-tertiary);
          transform: scale(1.05);
        }

        /* ================= PLACEHOLDER CONTENT ================= */
        .placeholder-content {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          min-height: 400px;
          color: var(--text-tertiary);
          gap: 16px;
        }

        .placeholder-content h2 {
          font-size: 24px;
          color: var(--text-secondary);
        }

        .placeholder-content p {
          font-size: 15px;
        }
      
        /* ================= MOBILE RESPONSIVE ================= */
@media (max-width: 768px) {

  /* Sidebar hidden by default */
  .sidebar {
    transform: translateX(-100%);
  }

  /* Sidebar open state */
  .sidebar:not(.closed) {
    transform: translateX(0);
  }

  /* Main content should take full width */
  .main {
    margin-left: 0 !important;
  }

  /* Optional overlay (recommended UX) */
  .sidebar-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.45);
    z-index: 900;
  }
}

/* ================= MOBILE BOTTOM NAV ================= */

.bottom-nav {
  display: none;
    background: var(--bg-primary);
  border-top: 1px solid var(--border);

}

/* MOBILE ONLY */
@media (max-width: 768px) {
  /* Hide sidebar completely */
  .sidebar {
    display: none;
  }

  /* Make main full width */
  .main {
    margin-left: 0 !important;
  }

  /* Bottom nav */
  .bottom-nav {
    display: flex;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 56px;
    background: var(--bg, #000);
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    justify-content: space-around;
    align-items: center;
    z-index: 1000;
  }

  .bottom-nav button {
    
    background: none;
    border: none;
    color: #888;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .bottom-nav button.active {
    color: #fff;
  }

  /* Prevent content hiding behind nav */
  .content {
    padding-bottom: 70px;
  }

  /* Hide hamburger (optional – recommended) */
  .hamburger {
    display: none;
  }
}

body {
  overflow-x: hidden;   /* allows container-level scroll */
}

/* ================= TABLE BASE ================= */

/* Header */

.btn-icon {
  opacity: 1 !important;
  pointer-events: auto !important;
}


/* Row hover */
tbody tr:hover {
  background: var(--bg-secondary);
}

/* Status dots */
td span {
  font-weight: 600;
}



.btn-icon {
  color: var(--text-primary) !important;
}
.btn-icon:hover {
  color: var(--accent);
}

.btn-icon.danger {
  color: var(--danger);
}

.btn-icon.danger:hover {
  background: rgba(239, 68, 68, 0.1);
}

@media (max-width: 1024px) {
  .players-table th,
  .players-table td {
    font-size: 13px;
    padding: 10px 12px;
  }
}

@media (max-width: 768px) {
  .players-table th,
  .players-table td {
    font-size: 12px;
    padding: 8px 10px;
  }
}
.players-table th:last-child,
.players-table td:last-child {
  width: 110px;
  min-width: 100px;
  text-align: center;
}

/* ===== COLUMN WIDTH PRIORITIES ===== */
.players-table th:nth-child(1),
.players-table td:nth-child(1) {
  width: 14%; /* Name */
}

.players-table th:nth-child(2),
.players-table td:nth-child(2) {
  width: 14%; /* Pairing Code */
}

.players-table th:nth-child(3),
.players-table td:nth-child(3) {
  width: 12%; /* Location */
}

.players-table th:nth-child(4),
.players-table td:nth-child(4) {
  width: 14%; /* Group */
}

.players-table th:nth-child(5),
.players-table td:nth-child(5) {
  width: 14%; /* Current Playlist */
}

.players-table th:nth-child(6),
.players-table td:nth-child(6) {
  width: 10%; /* Status */
}

.players-table th:nth-child(7),
.players-table td:nth-child(7) {
  width: 12%; /* Last Seen */
}

.players-table th:last-child,
.players-table td:last-child {
  width: 110px; /* Actions */
}
/* Prevent ugly vertical wrapping */
.players-table td:nth-child(7),
.players-table th:nth-child(7) {
  white-space: nowrap;
}
.status-badge {
  white-space: nowrap;
}
.players-table td:nth-child(3),
.players-table td:nth-child(4),
.players-table td:nth-child(5) {
  word-break: normal;
  overflow-wrap: break-word;   /* ✅ breaks ONLY if needed */
  white-space: normal;
}
.no-schedule-placeholder {
  padding: 16px 0;
  margin: 12px 0 24px;
  text-align: center;
  color: var(--text-tertiary);
  font-size: 14px;
}
h3.section-title {
  font-size: clamp(22px, 2vw, 22px);
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 10px;
}
/* ================= PLAYERS TABLE → CARDS (MOBILE) ================= */
/* ================= PLAYERS TABLE → CARDS (MOBILE) ================= */
@media (max-width: 768px) {

  /* Hide table header */
  .players-table thead {
    display: none;
  }

  /* Convert table to card stack */
  .players-table,
  .players-table tbody {
    display: block;
    width: 100%;
  }

  .players-table tr {
    display: block;
    background: var(--bg-primary);
    border: 1px solid var(--border);
    border-radius: 12px;
    padding: 12px;
    margin-bottom: 14px;
  }

  /* Each cell becomes a row */
  .players-table td {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 10px;
    text-align: right;
    padding: 6px 0;
    border: none;
    white-space: normal;
  }
  .players-table td > * {
    text-align: right;
  }
  /* Label (left side) */
  .players-table td::before {
    content: attr(data-label);
    font-size: 12px;
    font-weight: 500;
    color: var(--text-tertiary);
    min-width: 110px;
    flex-shrink: 0;
    text-align: left;

  }

  /* Actions row styling */
  .players-table td[data-label="Actions"] {
    display: flex;
    text-align: right;
    gap: 12px;
  }

  .action-buttons {
    justify-content: flex-end;
    display: flex;
  }
}
.layout.dark .players-table tr {
  box-shadow: none;
  border-color: rgba(255,255,255,0.06);
}

.offline-banner{
    background:#fff3cd;
    color:#856404;
    border:1px solid #ffeeba;
    padding:10px 15px;
    margin-bottom:20px;
    border-radius:8px;
    text-align:center;
    font-weight:600;
}`, "",{"version":3,"sources":["webpack://./src/styles/dashboard.css"],"names":[],"mappings":"AAAA;EACE,mCAAmC;AACrC;AACA;UACU,qBAAqB;UACrB,uBAAuB;UACvB,sBAAsB;UACtB,uBAAuB;UACvB,yBAAyB;UACzB,wBAAwB;UACxB,iBAAiB;UACjB,uBAAuB;UACvB,iBAAiB;UACjB,uBAAuB;UACvB,kBAAkB;UAClB,kBAAkB;UAClB,iBAAiB;UACjB,gCAAgC;UAChC,mCAAmC;QACrC;;QAEA;UACE,qBAAqB;UACrB,uBAAuB;UACvB,sBAAsB;UACtB,uBAAuB;UACvB,yBAAyB;UACzB,wBAAwB;UACxB,iBAAiB;UACjB,uBAAuB;UACvB,iBAAiB;UACjB,uBAAuB;UACvB,kBAAkB;UAClB,kBAAkB;UAClB,iBAAiB;UACjB,4BAA4B;UAC5B,+BAA+B;QACjC;;QAEA;UACE,SAAS;UACT,UAAU;UACV,sBAAsB;QACxB;;QAEA,oDAAoD;QACpD;UACE,aAAa;UACb,aAAa;UACb,gBAAgB;UAChB,kBAAkB,SAAS,sCAAsC;UACjE,WAAW;UACX,gBAAgB;UAChB,+BAA+B;UAC/B,0BAA0B;UAC1B,oGAAoG;UACpG,iDAAiD;QACnD;;QAEA,4DAA4D;QAC5D;UACE,YAAY;UACZ,6BAA6B;UAC7B,sCAAsC;UACtC,aAAa;UACb,8BAA8B;UAC9B,mBAAmB;UACnB,iCAAiC;UACjC,cAAc;UACd,gCAAgC;UAChC,eAAe;UACf,MAAM;UACN,OAAO;UACP,QAAQ;UACR,aAAa;QACf;AACR;EACE;IACE,aAAa;EACf;AACF;QACQ;UACE,aAAa;UACb,mBAAmB;UACnB,SAAS;UACT,cAAc,SAAS,iBAAiB;;QAE1C;QACA;UACE,aAAa;UACb,sBAAsB;UACtB,QAAQ;QACV;;QAEA;UACE,eAAe;UACf,gBAAgB;UAChB,0BAA0B;UAC1B,SAAS;QACX;;QAEA;UACE,eAAe;UACf,2BAA2B;UAC3B,SAAS;QACX;;AAER,sBAAsB,oBAAoB;EACxC,WAAW,UAAU,uBAAuB;EAC5C,gBAAgB,KAAK,sBAAsB;EAC3C,mBAAmB;EACnB,cAAc;AAChB;QACQ;EACN,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB,SAAS,yBAAyB;EACzD,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,0BAA0B,MAAM,eAAe;EAC/C,qDAAqD;IACnD,qBAAqB,IAAI,mCAAmC;MAC1D,sBAAsB,MAAM,uBAAuB;QACjD,QAAQ;;;;AAIhB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,WAAW,eAAe,gBAAgB;EAC1C,+BAA+B;EAC/B,kBAAkB;EAClB,kDAAkD;AACpD;QACQ;UACE,aAAa;UACb,mBAAmB;UACnB,SAAS;QACX;;QAEA;UACE,WAAW;UACX,YAAY;UACZ,mBAAmB;UACnB,+BAA+B;UAC/B,+BAA+B;UAC/B,aAAa;UACb,mBAAmB;UACnB,uBAAuB;UACvB,eAAe;UACf,eAAe;UACf,yBAAyB;QAC3B;;QAEA;UACE,8BAA8B;UAC9B,sBAAsB;QACxB;;QAEA;UACE,aAAa;UACb,mBAAmB;UACnB,SAAS;UACT,yBAAyB;UACzB,+BAA+B;UAC/B,mBAAmB;UACnB,+BAA+B;UAC/B,eAAe;UACf,yBAAyB;QAC3B;;QAEA;UACE,8BAA8B;QAChC;;QAEA;UACE,WAAW;UACX,YAAY;UACZ,kBAAkB;UAClB,2DAA2D;UAC3D,aAAa;UACb,mBAAmB;UACnB,uBAAuB;UACvB,YAAY;UACZ,gBAAgB;UAChB,eAAe;QACjB;;QAEA;UACE,eAAe;UACf,gBAAgB;UAChB,0BAA0B;QAC5B;;QAEA,gDAAgD;QAChD;UACE,YAAY;UACZ,6BAA6B;UAC7B,qCAAqC;UACrC,kBAAkB;UAClB,aAAa;UACb,sBAAsB;UACtB,eAAe;UACf,SAAS,EAAE,iBAAiB;UAC5B,OAAO;UACP,0BAA0B;UAC1B,aAAa;UACb,qDAAqD;QACvD;;QAEA;UACE,4BAA4B;QAC9B;;QAEA;UACE,aAAa;UACb,sBAAsB;UACtB,QAAQ;QACV;;QAEA;UACE,aAAa;UACb,mBAAmB;UACnB,SAAS;UACT,kBAAkB;UAClB,uBAAuB;UACvB,YAAY;UACZ,mBAAmB;UACnB,4BAA4B;UAC5B,eAAe;UACf,gBAAgB;UAChB,eAAe;UACf,yBAAyB;UACzB,WAAW;UACX,gBAAgB;YACd,aAAa;;QAEjB;;QAEA;UACE,8BAA8B;UAC9B,0BAA0B;YACxB,UAAU;;QAEd;;QAEA;UACE,yBAAyB;EACjC,cAAc,cAAc,sBAAsB;UAC1C,+CAA+C;QACjD;;QAEA;UACE,cAAc;QAChB;;QAEA,kDAAkD;QAClD;UACE,kBAAkB;UAClB,gBAAgB,EAAE,iBAAiB;UACnC,SAAO;UACP,aAAa;UACb,sBAAsB;UACtB,8BAA8B;UAC9B,gBAAgB;UAChB,YAAY,cAAc,oCAAoC;UAC9D,YAAY;UACZ,iCAAiC;QACnC;;QAEA;UACE,cAAc;QAChB;;QAEA,2DAA2D;QAC3D;UACE,gCAAgC;UAChC,gBAAgB;UAChB,SAAO;UACP,WAAW;;QAEb;;QAEA,mDAAmD;QACnD;UACE,aAAa;UACb;WACC;UACD,2BAA2B;UAC3B,mBAAmB;QACrB;;QAEA;UACE,6BAA6B;UAC7B,+BAA+B;SAChC,+BAA+B;EACtC,qCAAqC;UAC7B,aAAa;UACb,SAAS;UACT,yBAAyB;UACzB,kBAAkB;UAClB,gBAAgB;QAClB;;QAEA;UACE,WAAW;UACX,kBAAkB;UAClB,MAAM;UACN,OAAO;UACP,QAAQ;UACR,WAAW;UACX,yBAAyB;UACzB,UAAU;UACV,6BAA6B;QAC/B;;QAEA;UACE,2BAA2B;UAC3B,uCAAuC;QACzC;;QAEA;UACE,UAAU;QACZ;;QAEA,6BAA6B,yBAAyB,EAAE;QACxD,6BAA6B,0BAA0B,EAAE;QACzD,6BAA6B,0BAA0B,EAAE;QACzD,4BAA4B,yBAAyB,EAAE;;QAEvD;UACE,WAAW;UACX,YAAY;UACZ,mBAAmB;UACnB,aAAa;UACb,mBAAmB;UACnB,uBAAuB;UACvB,cAAc;UACd,+BAA+B;UAC/B,oBAAoB;QACtB;;QAEA;UACE,mCAAmC;UACnC,oBAAoB;QACtB;;QAEA;UACE,mCAAmC;UACnC,qBAAqB;QACvB;;QAEA;UACE,mCAAmC;UACnC,qBAAqB;QACvB;;QAEA;UACE,kCAAkC;UAClC,oBAAoB;QACtB;;QAEA;UACE,SAAO;QACT;;QAEA;UACE,eAAe;UACf,gBAAgB;UAChB,2BAA2B;UAC3B,kBAAkB;UAClB,yBAAyB;UACzB,qBAAqB;QACvB;AACR,6CAA6C;AAC7C;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B,EAAE,4BAA4B;EACzD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;EACf,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,0CAA0C;AAC5C;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,6BAA6B;EAC7B,0BAA0B;AAC5B;QACQ;UACE,eAAe;UACf,gBAAgB;UAChB,0BAA0B;UAC1B,SAAS;UACT,cAAc;QAChB;;QAEA;UACE,eAAe;UACf,2BAA2B;UAC3B,eAAe;QACjB;;QAEA;UACE,eAAe;UACf,eAAe;UACf,gBAAgB;UAChB,kBAAkB;UAClB,qBAAqB;QACvB;;QAEA;UACE,mCAAmC;UACnC,qBAAqB;QACvB;;QAEA;UACE,WAAW;UACX,WAAW;UACX,+BAA+B;UAC/B,kBAAkB;UAClB,gBAAgB;UAChB,gBAAgB;QAClB;;QAEA;UACE,YAAY;UACZ,kBAAkB;UAClB,2BAA2B;QAC7B;;QAEA;UACE,0BAA0B;QAC5B;;QAEA;UACE,UAAU;UACV,WAAW;UACX,kBAAkB;UAClB,qBAAqB;QACvB;;QAEA;UACE,0BAA0B;UAC1B,kCAAkC;QACpC;;QAEA;UACE,yBAAyB;UACzB,iCAAiC;QACnC;;QAEA,uDAAuD;QACvD;UACE,aAAa;UACb,8BAA8B;UAC9B,mBAAmB;UACnB,mBAAmB;QACrB;;QAEA;UACE,eAAe;UACf,gBAAgB;UAChB,0BAA0B;QAC5B;;QAEA;UACE,iBAAiB;UACjB,+BAA+B;UAC/B,+BAA+B;UAC/B,kBAAkB;UAClB,0BAA0B;UAC1B,eAAe;UACf,gBAAgB;UAChB,eAAe;UACf,yBAAyB;QAC3B;;QAEA;UACE,8BAA8B;QAChC;;QAEA,sDAAsD;QACtD;;UAEE,6BAA6B;UAC7B,+BAA+B;UAC/B,mBAAmB;EAC3B,iBAAiB,eAAe,gCAAgC;QAC1D;;QAEA;UACE,WAAW;EACnB,mBAAmB,QAAQ,uCAAuC;EAClE,yBAAyB;EACzB,iBAAiB;QACX;;QAEA;UACE,+BAA+B;QACjC;;QAEA;UACE,kBAAkB;UAClB,gBAAgB;UAChB,eAAe;UACf,gBAAgB;UAChB,2BAA2B;UAC3B,yBAAyB;UACzB,qBAAqB;UACrB,sCAAsC;WACrC,mBAAmB;EAC5B,kBAAkB;aACP,mBAAmB;;QAExB;;QAEA;UACE,kBAAkB;UAClB,4CAA4C;WAC3C,mBAAmB;EAC5B,kBAAkB;IAChB,YAAY,SAAS,wCAAwC;;QAEzD;;QAEA;UACE,mBAAmB;QACrB;;QAEA;UACE,gCAAgC;QAClC;;QAEA;UACE,+BAA+B;QACjC;;QAEA;UACE,aAAa;UACb,mBAAmB;UACnB,SAAS;UACT,0BAA0B;UAC1B,gBAAgB;QAClB;;QAEA;UACE,oBAAoB;UACpB,mBAAmB;UACnB,QAAQ;UACR,iBAAiB;UACjB,kBAAkB;UAClB,eAAe;UACf,gBAAgB;QAClB;;QAEA;UACE,mCAAmC;UACnC,qBAAqB;QACvB;;QAEA;UACE,kCAAkC;UAClC,oBAAoB;QACtB;;QAEA;UACE,UAAU;UACV,WAAW;QACb;;QAEA;UACE,iBAAiB;UACjB,+BAA+B;UAC/B,kBAAkB;UAClB,eAAe;UACf,0BAA0B;QAC5B;;QAEA;UACE,2BAA2B;UAC3B,eAAe;QACjB;;QAEA;UACE,QAAQ;UACR,uBAAuB;QACzB;;QAEA;UACE,WAAW;UACX,YAAY;UACZ,kBAAkB;UAClB,+BAA+B;UAC/B,+BAA+B;UAC/B,aAAa;UACb,mBAAmB;UACnB,uBAAuB;UACvB,eAAe;UACf,cAAc;UACd,eAAe;UACf,yBAAyB;QAC3B;;QAEA;UACE,8BAA8B;UAC9B,sBAAsB;QACxB;;QAEA,4DAA4D;QAC5D;UACE,aAAa;UACb,sBAAsB;UACtB,mBAAmB;UACnB,uBAAuB;UACvB,iBAAiB;UACjB,2BAA2B;UAC3B,SAAS;QACX;;QAEA;UACE,eAAe;UACf,4BAA4B;QAC9B;;QAEA;UACE,eAAe;QACjB;;QAEA,0DAA0D;AAClE;;EAEE,8BAA8B;EAC9B;IACE,4BAA4B;EAC9B;;EAEA,uBAAuB;EACvB;IACE,wBAAwB;EAC1B;;EAEA,wCAAwC;EACxC;IACE,yBAAyB;EAC3B;;EAEA,sCAAsC;EACtC;IACE,eAAe;IACf,QAAQ;IACR,4BAA4B;IAC5B,YAAY;EACd;AACF;;AAEA,0DAA0D;;AAE1D;EACE,aAAa;IACX,6BAA6B;EAC/B,mCAAmC;;AAErC;;AAEA,gBAAgB;AAChB;EACE,4BAA4B;EAC5B;IACE,aAAa;EACf;;EAEA,yBAAyB;EACzB;IACE,yBAAyB;EAC3B;;EAEA,eAAe;EACf;IACE,aAAa;IACb,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,2BAA2B;IAC3B,8CAA8C;IAC9C,6BAA6B;IAC7B,mBAAmB;IACnB,aAAa;EACf;;EAEA;;IAEE,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA,sCAAsC;EACtC;IACE,oBAAoB;EACtB;;EAEA,4CAA4C;EAC5C;IACE,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB,IAAI,kCAAkC;AAC1D;;AAEA,mDAAmD;;AAEnD,WAAW;;AAEX;EACE,qBAAqB;EACrB,+BAA+B;AACjC;;;AAGA,cAAc;AACd;EACE,+BAA+B;AACjC;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;AAClB;;;;AAIA;EACE,qCAAqC;AACvC;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE;;IAEE,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA;EACE;;IAEE,eAAe;IACf,iBAAiB;EACnB;AACF;AACA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,wCAAwC;AACxC;;EAEE,UAAU,EAAE,SAAS;AACvB;;AAEA;;EAEE,UAAU,EAAE,iBAAiB;AAC/B;;AAEA;;EAEE,UAAU,EAAE,aAAa;AAC3B;;AAEA;;EAEE,UAAU,EAAE,UAAU;AACxB;;AAEA;;EAEE,UAAU,EAAE,qBAAqB;AACnC;;AAEA;;EAEE,UAAU,EAAE,WAAW;AACzB;;AAEA;;EAEE,UAAU,EAAE,cAAc;AAC5B;;AAEA;;EAEE,YAAY,EAAE,YAAY;AAC5B;AACA,mCAAmC;AACnC;;EAEE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;;;EAGE,kBAAkB;EAClB,yBAAyB,IAAI,4BAA4B;EACzD,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;AACA,uEAAuE;AACvE,uEAAuE;AACvE;;EAEE,sBAAsB;EACtB;IACE,aAAa;EACf;;EAEA,gCAAgC;EAChC;;IAEE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,cAAc;IACd,6BAA6B;IAC7B,+BAA+B;IAC/B,mBAAmB;IACnB,aAAa;IACb,mBAAmB;EACrB;;EAEA,4BAA4B;EAC5B;IACE,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;IACT,iBAAiB;IACjB,cAAc;IACd,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA,sBAAsB;EACtB;IACE,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,gBAAgB;IAChB,cAAc;IACd,gBAAgB;;EAElB;;EAEA,wBAAwB;EACxB;IACE,aAAa;IACb,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,yBAAyB;IACzB,aAAa;EACf;AACF;AACA;EACE,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,wBAAwB;IACxB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;AACnB","sourcesContent":["html {\n  font-size: clamp(14px, 1.2vw, 16px);\n}\n.layout.light {\n          --bg-primary: #ffffff;\n          --bg-secondary: #f8fafc;\n          --bg-tertiary: #f1f5f9;\n          --text-primary: #0f172a;\n          --text-secondary: #475569;\n          --text-tertiary: #94a3b8;\n          --border: #e2e8f0;\n          --border-light: #f1f5f9;\n          --accent: #3b82f6;\n          --accent-hover: #2563eb;\n          --success: #10b981;\n          --warning: #f59e0b;\n          --danger: #ef4444;\n          --shadow: rgba(15, 23, 42, 0.08);\n          --shadow-lg: rgba(15, 23, 42, 0.12);\n        }\n\n        .layout.dark {\n          --bg-primary: #0f172a;\n          --bg-secondary: #1e293b;\n          --bg-tertiary: #334155;\n          --text-primary: #f1f5f9;\n          --text-secondary: #cbd5e1;\n          --text-tertiary: #64748b;\n          --border: #334155;\n          --border-light: #1e293b;\n          --accent: #3b82f6;\n          --accent-hover: #60a5fa;\n          --success: #10b981;\n          --warning: #f59e0b;\n          --danger: #ef4444;\n          --shadow: rgba(0, 0, 0, 0.3);\n          --shadow-lg: rgba(0, 0, 0, 0.5);\n        }\n\n        * {\n          margin: 0;\n          padding: 0;\n          box-sizing: border-box;\n        }\n\n        /* ================= BASE LAYOUT ================= */\n        .layout {\n          display: flex;\n          height: 100vh;\n          overflow: hidden;\n          min-height: 100dvh;        /* 🔥 dynamic viewport (mobile safe) */\n          width: 100%;\n          overflow: hidden;\n          background: var(--bg-secondary);\n          color: var(--text-primary);\n          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', sans-serif;\n          transition: background 0.3s ease, color 0.3s ease;\n        }\n\n        /* ================= TOPBAR (FULL WIDTH) ================= */\n        .topbar {\n          height: 72px;\n          background: var(--bg-primary);\n          border-bottom: 1px solid var(--border);\n          display: flex;\n          justify-content: space-between;\n          align-items: center;\n          padding: 0 clamp(12px, 4vw, 24px);\n          flex-shrink: 0;\n          transition: background 0.3s ease;\n          position: fixed;\n          top: 0;\n          left: 0;\n          right: 0;\n          z-index: 1100;\n        }\n@media (max-width: 600px) {\n  .user-name {\n    display: none;\n  }\n}\n        .topbar-left {\n          display: flex;\n          align-items: center;\n          gap: 28px;\n          flex-shrink: 0;        /* 🔥 IMPORTANT */\n\n        }\n        .title-group {\n          display: flex;\n          flex-direction: column;\n          gap: 2px;\n        }\n\n        .page-title {\n          font-size: 22px;\n          font-weight: 700;\n          color: var(--text-primary);\n          margin: 0;\n        }\n\n        .page-subtitle {\n          font-size: 14px;\n          color: var(--text-tertiary);\n          margin: 0;\n        }\n\n.topbar-logo {        /* controls height */\n  width: auto;         /* keeps aspect ratio */\n  max-width: 260px;    /* prevents overflow */\n  object-fit: contain;\n  display: block;\n}\n        .hamburger {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  background: transparent;        /* 🔥 remove filled box */\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: var(--text-primary);     /* icon color */\n  transition: background 0.2s ease, transform 0.1s ease;\n    padding: 0 !important;   /* override global button padding */\n      flex-direction: column;     /* 🔥 THIS is the key */\n        gap: 6px;\n\n\n\n}\n\n.hamburger:hover {\n  background: var(--bg-tertiary);\n}\n\n.hamburger:active {\n  transform: scale(0.95);\n}\n.hamburger span {\n  width: 28px;\n  height: 2px;              /* thick lines */\n  background: var(--text-primary);\n  border-radius: 2px;\n  transition: transform 0.2s ease, opacity 0.2s ease;\n}\n        .topbar-right {\n          display: flex;\n          align-items: center;\n          gap: 16px;\n        }\n\n        .theme-toggle {\n          width: 40px;\n          height: 40px;\n          border-radius: 10px;\n          background: var(--bg-secondary);\n          border: 1px solid var(--border);\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          cursor: pointer;\n          font-size: 18px;\n          transition: all 0.2s ease;\n        }\n\n        .theme-toggle:hover {\n          background: var(--bg-tertiary);\n          transform: scale(1.05);\n        }\n\n        .user-menu {\n          display: flex;\n          align-items: center;\n          gap: 12px;\n          padding: 8px 16px 8px 8px;\n          background: var(--bg-secondary);\n          border-radius: 12px;\n          border: 1px solid var(--border);\n          cursor: pointer;\n          transition: all 0.2s ease;\n        }\n\n        .user-menu:hover {\n          background: var(--bg-tertiary);\n        }\n\n        .user-avatar {\n          width: 36px;\n          height: 36px;\n          border-radius: 8px;\n          background: linear-gradient(135deg, var(--accent), #8b5cf6);\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          color: white;\n          font-weight: 600;\n          font-size: 14px;\n        }\n\n        .user-name {\n          font-size: 14px;\n          font-weight: 500;\n          color: var(--text-primary);\n        }\n\n        /* ================= SIDEBAR ================= */\n        .sidebar {\n          width: 200px;\n          background: var(--bg-primary);\n          border-right: 1px solid var(--border);\n          padding: 24px 16px;\n          display: flex;\n          flex-direction: column;\n          position: fixed;\n          top: 72px; /* below topbar */\n          left: 0;\n          height: calc(100vh - 72px);\n          z-index: 1000;\n          transition: transform 0.2s ease, background 0.3s ease;\n        }\n\n        .sidebar.closed {\n          transform: translateX(-100%);\n        }\n\n        .nav-menu {\n          display: flex;\n          flex-direction: column;\n          gap: 4px;\n        }\n\n        .nav-item {\n          display: flex;\n          align-items: center;\n          gap: 12px;\n          padding: 12px 16px;\n          background: transparent;\n          border: none;\n          border-radius: 10px;\n          color: var(--text-secondary);\n          font-size: 15px;\n          font-weight: 500;\n          cursor: pointer;\n          transition: all 0.2s ease;\n          width: 100%;\n          text-align: left;\n            opacity: 0.85;\n\n        }\n\n        .nav-item:hover {\n          background: var(--bg-tertiary);\n          color: var(--text-primary);\n            opacity: 1;\n\n        }\n\n        .nav-item.active {\n          background: var(--accent);\n  color: #ffffff;             /* ✅ clear, readable */\n          box-shadow: 0 4px 12px rgba(59, 130, 246, 0.25);\n        }\n\n        .nav-item svg {\n          flex-shrink: 0;\n        }\n\n        /* ================= MAIN AREA ================= */\n        .main {\n          margin-left: 200px;\n          margin-top: 72px; /* below topbar */\n          flex: 1;\n          display: flex;\n          flex-direction: column;\n          /*height: calc(100vh - 72px);*/\n          overflow: hidden;\n          min-width: 0;             /* 🔥 prevents horizontal overflow */\n          height: auto;\n          transition: margin-left 0.2s ease;\n        }\n\n        .main.full {\n          margin-left: 0;\n        }\n\n        /* ================= SCROLLABLE CONTENT ================= */\n        .content {\n          padding:  clamp(16px, 4vw, 32px);   \n          overflow-y: auto;\n          flex: 1;\n          width: 100%;\n\n        }\n\n        /* ================= STATS GRID ================= */\n        .stats-grid {\n          display: grid;\n          grid-template-columns: repeat(auto-fit,     minmax(min(100%, 240px), 1fr)\n          );\n          gap: clamp(12px, 3vw, 20px);\n          margin-bottom: 32px;\n        }\n\n        .stat-card {\n          background: var(--bg-primary);\n          border: 1px solid var(--border);\n         padding: clamp(16px, 3vw, 24px);\n  border-radius: clamp(12px, 3vw, 16px);\n          display: flex;\n          gap: 16px;\n          transition: all 0.3s ease;\n          position: relative;\n          overflow: hidden;\n        }\n\n        .stat-card::before {\n          content: '';\n          position: absolute;\n          top: 0;\n          left: 0;\n          right: 0;\n          height: 3px;\n          background: var(--accent);\n          opacity: 0;\n          transition: opacity 0.3s ease;\n        }\n\n        .stat-card:hover {\n          transform: translateY(-2px);\n          box-shadow: 0 8px 24px var(--shadow-lg);\n        }\n\n        .stat-card:hover::before {\n          opacity: 1;\n        }\n\n        .stat-card.primary::before { background: var(--accent); }\n        .stat-card.success::before { background: var(--success); }\n        .stat-card.warning::before { background: var(--warning); }\n        .stat-card.danger::before { background: var(--danger); }\n\n        .stat-icon {\n          width: 48px;\n          height: 48px;\n          border-radius: 12px;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          flex-shrink: 0;\n          background: var(--bg-secondary);\n          color: var(--accent);\n        }\n\n        .stat-card.primary .stat-icon {\n          background: rgba(59, 130, 246, 0.1);\n          color: var(--accent);\n        }\n\n        .stat-card.success .stat-icon {\n          background: rgba(16, 185, 129, 0.1);\n          color: var(--success);\n        }\n\n        .stat-card.warning .stat-icon {\n          background: rgba(245, 158, 11, 0.1);\n          color: var(--warning);\n        }\n\n        .stat-card.danger .stat-icon {\n          background: rgba(239, 68, 68, 0.1);\n          color: var(--danger);\n        }\n\n        .stat-content {\n          flex: 1;\n        }\n\n        .stat-label {\n          font-size: 13px;\n          font-weight: 500;\n          color: var(--text-tertiary);\n          margin-bottom: 4px;\n          text-transform: uppercase;\n          letter-spacing: 0.5px;\n        }\n/* ===== Input group (calendar field) ===== */\n.input-group {\n  position: relative;\n  width: 100%;\n}\n\n.input-group input {\n  width: 100%;\n  padding: 12px 42px 12px 12px;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  font-size: 14px;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n}\n\n/* FIXED ICON ALIGNMENT */\n.input-icon {\n  position: absolute;\n  top: 50%;\n  right: 12px;\n  transform: translateY(-50%); /* 🔥 THIS FIXES ALIGNMENT */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-tertiary);\n  font-size: 18px;\n  pointer-events: auto;\n  cursor: pointer;\n}\n.modal label {\n  display: block;\n  margin-top: 14px;\n  margin-bottom: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-secondary);\n}\n.error-text {\n  color: var(--danger);\n  font-size: 12px;\n  margin-top: 4px;\n}\n\n.input-error {\n  border: 1px solid var(--danger) !important;\n}\n.modal input,\n.modal select {\n  width: 100%;\n  padding: 10px 12px;\n  border-radius: 8px;\n  border: 1px solid var(--border);\n  background: var(--bg-primary);\n  color: var(--text-primary);\n}\n        .stat-value {\n          font-size: 32px;\n          font-weight: 700;\n          color: var(--text-primary);\n          margin: 0;\n          line-height: 1;\n        }\n\n        .stat-description {\n          font-size: 13px;\n          color: var(--text-tertiary);\n          margin-top: 4px;\n        }\n\n        .stat-trend {\n          font-size: 12px;\n          margin-top: 8px;\n          padding: 4px 8px;\n          border-radius: 6px;\n          display: inline-block;\n        }\n\n        .stat-trend.positive {\n          background: rgba(16, 185, 129, 0.1);\n          color: var(--success);\n        }\n\n        .stat-progress {\n          width: 100%;\n          height: 4px;\n          background: var(--bg-secondary);\n          border-radius: 2px;\n          margin-top: 12px;\n          overflow: hidden;\n        }\n\n        .stat-progress-bar {\n          height: 100%;\n          border-radius: 2px;\n          transition: width 0.3s ease;\n        }\n\n        .stat-progress-bar.success {\n          background: var(--success);\n        }\n\n        .status-dot {\n          width: 8px;\n          height: 8px;\n          border-radius: 50%;\n          display: inline-block;\n        }\n\n        .status-dot.online {\n          background: var(--success);\n          box-shadow: 0 0 8px var(--success);\n        }\n\n        .status-dot.offline {\n          background: var(--danger);\n          box-shadow: 0 0 8px var(--danger);\n        }\n\n        /* ================= SECTION HEADER ================= */\n        .section-header {\n          display: flex;\n          justify-content: space-between;\n          align-items: center;\n          margin-bottom: 20px;\n        }\n\n        .section-header h2 {\n          font-size: 20px;\n          font-weight: 700;\n          color: var(--text-primary);\n        }\n\n        .btn-secondary {\n          padding: 8px 16px;\n          background: var(--bg-secondary);\n          border: 1px solid var(--border);\n          border-radius: 8px;\n          color: var(--text-primary);\n          font-size: 14px;\n          font-weight: 500;\n          cursor: pointer;\n          transition: all 0.2s ease;\n        }\n\n        .btn-secondary:hover {\n          background: var(--bg-tertiary);\n        }\n\n        /* ================= PLAYERS TABLE ================= */\n        .table-container,\n        .players-table-container {\n          background: var(--bg-primary);\n          border: 1px solid var(--border);\n          border-radius: 16px;\n  overflow: visible;              /* 🔥 ENABLE horizontal scroll */\n        }\n\n        .players-table {\n          width: 100%;\n  table-layout: fixed;       /* 🔥 KEY: forces proportional shrink */\n  border-collapse: separate;\n  border-spacing: 0;\n        }\n\n        .players-table thead {\n          background: var(--bg-secondary);\n        }\n\n        .players-table th {\n          padding: 16px 20px;\n          text-align: left;\n          font-size: 12px;\n          font-weight: 600;\n          color: var(--text-tertiary);\n          text-transform: uppercase;\n          letter-spacing: 0.5px;\n          border-bottom: 1px solid var(--border);\n           white-space: nowrap;\n  padding: 12px 14px;\n             white-space: nowrap;\n\n        }\n\n        .players-table td {\n          padding: 16px 20px;\n          border-bottom: 1px solid var(--border-light);\n           white-space: nowrap;\n  padding: 12px 14px;\n    max-width: 0;        /* 🔥 enables wrapping in fixed layout */\n\n        }\n\n        .players-table tbody tr:last-child td {\n          border-bottom: none;\n        }\n\n        .players-table tbody tr {\n          transition: background 0.2s ease;\n        }\n\n        .players-table tbody tr:hover {\n          background: var(--bg-secondary);\n        }\n\n        .player-name {\n          display: flex;\n          align-items: center;\n          gap: 10px;\n          color: var(--text-primary);\n          font-weight: 500;\n        }\n\n        .status-badge {\n          display: inline-flex;\n          align-items: center;\n          gap: 6px;\n          padding: 6px 12px;\n          border-radius: 8px;\n          font-size: 13px;\n          font-weight: 500;\n        }\n\n        .status-badge.online {\n          background: rgba(16, 185, 129, 0.1);\n          color: var(--success);\n        }\n\n        .status-badge.offline {\n          background: rgba(239, 68, 68, 0.1);\n          color: var(--danger);\n        }\n\n        .status-badge .status-dot {\n          width: 6px;\n          height: 6px;\n        }\n\n        .playlist-badge {\n          padding: 6px 12px;\n          background: var(--bg-secondary);\n          border-radius: 8px;\n          font-size: 13px;\n          color: var(--text-primary);\n        }\n\n        .text-muted {\n          color: var(--text-tertiary);\n          font-size: 13px;\n        }\n\n        .action-buttons {\n          gap: 8px;\n          justify-content: center;\n        }\n\n        .btn-icon {\n          width: 32px;\n          height: 32px;\n          border-radius: 6px;\n          background: var(--bg-secondary);\n          border: 1px solid var(--border);\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          cursor: pointer;\n          flex-shrink: 0;\n          font-size: 16px;\n          transition: all 0.2s ease;\n        }\n\n        .btn-icon:hover {\n          background: var(--bg-tertiary);\n          transform: scale(1.05);\n        }\n\n        /* ================= PLACEHOLDER CONTENT ================= */\n        .placeholder-content {\n          display: flex;\n          flex-direction: column;\n          align-items: center;\n          justify-content: center;\n          min-height: 400px;\n          color: var(--text-tertiary);\n          gap: 16px;\n        }\n\n        .placeholder-content h2 {\n          font-size: 24px;\n          color: var(--text-secondary);\n        }\n\n        .placeholder-content p {\n          font-size: 15px;\n        }\n      \n        /* ================= MOBILE RESPONSIVE ================= */\n@media (max-width: 768px) {\n\n  /* Sidebar hidden by default */\n  .sidebar {\n    transform: translateX(-100%);\n  }\n\n  /* Sidebar open state */\n  .sidebar:not(.closed) {\n    transform: translateX(0);\n  }\n\n  /* Main content should take full width */\n  .main {\n    margin-left: 0 !important;\n  }\n\n  /* Optional overlay (recommended UX) */\n  .sidebar-overlay {\n    position: fixed;\n    inset: 0;\n    background: rgba(0,0,0,0.45);\n    z-index: 900;\n  }\n}\n\n/* ================= MOBILE BOTTOM NAV ================= */\n\n.bottom-nav {\n  display: none;\n    background: var(--bg-primary);\n  border-top: 1px solid var(--border);\n\n}\n\n/* MOBILE ONLY */\n@media (max-width: 768px) {\n  /* Hide sidebar completely */\n  .sidebar {\n    display: none;\n  }\n\n  /* Make main full width */\n  .main {\n    margin-left: 0 !important;\n  }\n\n  /* Bottom nav */\n  .bottom-nav {\n    display: flex;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 56px;\n    background: var(--bg, #000);\n    border-top: 1px solid rgba(255, 255, 255, 0.1);\n    justify-content: space-around;\n    align-items: center;\n    z-index: 1000;\n  }\n\n  .bottom-nav button {\n    \n    background: none;\n    border: none;\n    color: #888;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .bottom-nav button.active {\n    color: #fff;\n  }\n\n  /* Prevent content hiding behind nav */\n  .content {\n    padding-bottom: 70px;\n  }\n\n  /* Hide hamburger (optional – recommended) */\n  .hamburger {\n    display: none;\n  }\n}\n\nbody {\n  overflow-x: hidden;   /* allows container-level scroll */\n}\n\n/* ================= TABLE BASE ================= */\n\n/* Header */\n\n.btn-icon {\n  opacity: 1 !important;\n  pointer-events: auto !important;\n}\n\n\n/* Row hover */\ntbody tr:hover {\n  background: var(--bg-secondary);\n}\n\n/* Status dots */\ntd span {\n  font-weight: 600;\n}\n\n\n\n.btn-icon {\n  color: var(--text-primary) !important;\n}\n.btn-icon:hover {\n  color: var(--accent);\n}\n\n.btn-icon.danger {\n  color: var(--danger);\n}\n\n.btn-icon.danger:hover {\n  background: rgba(239, 68, 68, 0.1);\n}\n\n@media (max-width: 1024px) {\n  .players-table th,\n  .players-table td {\n    font-size: 13px;\n    padding: 10px 12px;\n  }\n}\n\n@media (max-width: 768px) {\n  .players-table th,\n  .players-table td {\n    font-size: 12px;\n    padding: 8px 10px;\n  }\n}\n.players-table th:last-child,\n.players-table td:last-child {\n  width: 110px;\n  min-width: 100px;\n  text-align: center;\n}\n\n/* ===== COLUMN WIDTH PRIORITIES ===== */\n.players-table th:nth-child(1),\n.players-table td:nth-child(1) {\n  width: 14%; /* Name */\n}\n\n.players-table th:nth-child(2),\n.players-table td:nth-child(2) {\n  width: 14%; /* Pairing Code */\n}\n\n.players-table th:nth-child(3),\n.players-table td:nth-child(3) {\n  width: 12%; /* Location */\n}\n\n.players-table th:nth-child(4),\n.players-table td:nth-child(4) {\n  width: 14%; /* Group */\n}\n\n.players-table th:nth-child(5),\n.players-table td:nth-child(5) {\n  width: 14%; /* Current Playlist */\n}\n\n.players-table th:nth-child(6),\n.players-table td:nth-child(6) {\n  width: 10%; /* Status */\n}\n\n.players-table th:nth-child(7),\n.players-table td:nth-child(7) {\n  width: 12%; /* Last Seen */\n}\n\n.players-table th:last-child,\n.players-table td:last-child {\n  width: 110px; /* Actions */\n}\n/* Prevent ugly vertical wrapping */\n.players-table td:nth-child(7),\n.players-table th:nth-child(7) {\n  white-space: nowrap;\n}\n.status-badge {\n  white-space: nowrap;\n}\n.players-table td:nth-child(3),\n.players-table td:nth-child(4),\n.players-table td:nth-child(5) {\n  word-break: normal;\n  overflow-wrap: break-word;   /* ✅ breaks ONLY if needed */\n  white-space: normal;\n}\n.no-schedule-placeholder {\n  padding: 16px 0;\n  margin: 12px 0 24px;\n  text-align: center;\n  color: var(--text-tertiary);\n  font-size: 14px;\n}\nh3.section-title {\n  font-size: clamp(22px, 2vw, 22px);\n  font-weight: 700;\n  color: var(--text-primary);\n  margin-bottom: 10px;\n}\n/* ================= PLAYERS TABLE → CARDS (MOBILE) ================= */\n/* ================= PLAYERS TABLE → CARDS (MOBILE) ================= */\n@media (max-width: 768px) {\n\n  /* Hide table header */\n  .players-table thead {\n    display: none;\n  }\n\n  /* Convert table to card stack */\n  .players-table,\n  .players-table tbody {\n    display: block;\n    width: 100%;\n  }\n\n  .players-table tr {\n    display: block;\n    background: var(--bg-primary);\n    border: 1px solid var(--border);\n    border-radius: 12px;\n    padding: 12px;\n    margin-bottom: 14px;\n  }\n\n  /* Each cell becomes a row */\n  .players-table td {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 10px;\n    text-align: right;\n    padding: 6px 0;\n    border: none;\n    white-space: normal;\n  }\n  .players-table td > * {\n    text-align: right;\n  }\n  /* Label (left side) */\n  .players-table td::before {\n    content: attr(data-label);\n    font-size: 12px;\n    font-weight: 500;\n    color: var(--text-tertiary);\n    min-width: 110px;\n    flex-shrink: 0;\n    text-align: left;\n\n  }\n\n  /* Actions row styling */\n  .players-table td[data-label=\"Actions\"] {\n    display: flex;\n    text-align: right;\n    gap: 12px;\n  }\n\n  .action-buttons {\n    justify-content: flex-end;\n    display: flex;\n  }\n}\n.layout.dark .players-table tr {\n  box-shadow: none;\n  border-color: rgba(255,255,255,0.06);\n}\n\n.offline-banner{\n    background:#fff3cd;\n    color:#856404;\n    border:1px solid #ffeeba;\n    padding:10px 15px;\n    margin-bottom:20px;\n    border-radius:8px;\n    text-align:center;\n    font-weight:600;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
